import React from "react";

import ContentWrapper from "./ContentWrapper";
import { CookieConsentBar } from "./CookieConsent";
import Footer from "./Footer";
import MiniHeader from "./MiniHeader";

const SubPage = ({
  top,
  children,
}: {
  top?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div className="page">
      <CookieConsentBar />
      <MiniHeader />
      <ContentWrapper top={top}>{children}</ContentWrapper>
      <Footer />
    </div>
  );
};

export default SubPage;
